export * from 'server/models/AuthorizedData';


// WEBPACK FOOTER //
// ./data/models/AuthorizedData.ts